import { action } from "typesafe-actions";
import ActionTypes from "../constants";

export const reviewPageLoaded = (ekind = "", edata = {}, odata = {}) =>
  action(ActionTypes.TRACK, {
    ekind: ekind || "renewal_review_screen_loaded",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Payment_Page",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const addonPageLoaded = (ekind = "", edata = {}, odata = {}) =>
  action(ActionTypes.TRACK, {
    ekind: ekind || "renewal_add_on_screen_loaded",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_add_on_screen",
      ls: true,
      product_state: "Payment_Page",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const addonPageRedirected = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "renewal_add_on_screen_redirected",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const reviewPayNowClicked = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "renewal_pay_now_clicked",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const customIdvSelected = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "renewal_custom_idv_selected",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const newNcbInfoClicked = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "new_ncb_info_clicked",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const dynamicSectionInfoClicked = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "dynamic_section_info_clicked",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const dynamicSectionChangePlanClicked = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "dynamic_section_change_plan_clicked",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const couponApplied = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "coupon_code_tap_to_apply",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const couponRemoved = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "coupon_code_removed",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const recommendCouponLoaded = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "recommended_coupon_loaded",
    okind: "auto_proposal",
    edata: {
      screen: "payment_option_selection_screen",
      ...edata
    },
    ...odata
  });

export const invalidCouponApplied = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "invalid_coupon_code",
    okind: "auto_proposal",
    edata: {
      screen: "payment_option_selection_screen",
      ...edata
    },
    ...odata
  });

export const addonAdded = ({ ekind = {}, edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind,
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const addonRemoved = ({ ekind = {}, edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind,
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const addonInfoClicked = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "add_on_info_clicked",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const carDetailsClicked = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "vehicle_details_clicked",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const ownerDetailsClicked = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "owner_details_clicked",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const premiumBreakupClicked = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "premium_breakup_clicked",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const previousAddonDropdown = ({ ekind = {}, edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind,
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const plansPageInfoClicked = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "renewal_plan_page_bottom_banner_info_clicked",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const renewalDateInfoClicked = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "renewal_expiry_banner_info_clicked",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const whyAckoSeeDetailsClicked = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "why_acko_see_details_clicked",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const ncbUpdateModalLoaded = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "renewal_ncb_update_modal_loaded",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const tapBtnNcbUpdateModalCta = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "renewal_tap_btn_ncb_update_modal_cta",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const tapBtnIdvWhatsThis = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "renewal_tap_btn_idv_whats_this",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const renewalPriceChangeModalLoaded = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "renewal_price_change_modal_loaded",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const renewalPriceChangeModalClosed = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "renewal_price_change_modal_closed",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const preInspectionRequiredModalLoaded = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "renewal_pre_inspection_required_modal_loaded",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const tapBtnPreInspectionRequiredModalCta = ({
  edata = {},
  odata = {}
}) =>
  action(ActionTypes.TRACK, {
    ekind: "renewal_tap_btn_pre_inspection_required_modal_cta",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const tapBtnRemovePaCoverModal = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "renewal_tap_btn_remove_pa_cover_modal",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const tapBtnContinueWithPaCoverModal = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "renewal_tap_btn_continue_with_pa_cover_modal",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const tapBtnPreviousYearAddons = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "renewal_tap_btn_previous_year_addons",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const tapBtnAddonNudge = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "renewal_tap_btn_addon_nudge",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const deductibleConfirmationModalLoaded = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "renewal_deductible_confirmation_modal_loaded",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const deductibleConfirmationModalConfirmed = ({
  edata = {},
  odata = {}
}) =>
  action(ActionTypes.TRACK, {
    ekind: "renewal_deductible_confirmation_modal_confirmed",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const changePreviousPolicyAddons = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "renewal_change_previous_policy_addons",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const tenureNudgeCtaClicked = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "tap_btn_multi_year_modal_cta",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const tenureNudgeSelection = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "tap_btn_plan_tenure_modal",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const tenureNudgeLoaded = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "tenure_nudge_modal_loaded",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });

export const nudgeCloseClicked = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "modal_cross_clicked",
    okind: "auto_proposal",
    edata,
    ...odata
  });

export const renewalEditDetailsClicked = ({ edata = {}, odata = {} }) =>
  action(ActionTypes.TRACK, {
    ekind: "renewal_edit_details_clicked",
    okind: "auto_proposal",
    edata: {
      screen: "renewal_review_screen",
      ls: true,
      product_state: "Renewal Payment Screen",
      lob: "direct",
      ...edata
    },
    ...odata
  });
